<div class="card">
  <div class="section-2">
    <div>
      {{ question?.title }}
    </div>
    <div class="form-container" style="margin-top: 10px">
      <mat-form-field hideRequiredMarker="true">
        <input matInput placeholder="Feedback" [formControl]="formControl" />
      </mat-form-field>
    </div>
  </div>
</div>
